import arrayUtils from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/utils/array-utils';
import config from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/services/config';

var initialState = {
    // The attributes for the current category
    categoryAttributes: [],
    // The attributes of the draft.
    /**
     draftAttributes: {
      termAttributeValues: [
        {
          id: 1,
          backingField: 'clothes_size',
          userGenerated: true,
          values: [
            'b'
          ]
        }
      ],
      numberAttributeValues: []
    }
     */
    draftAttributes: {},
    // A list of the selected attributes (draftAttributes) for display on the page.
    // Exists for ease of use in views.
    // Format:
    /**
     {
         title: 'Klädstorlek',
         value: 'L'
     }
     */
    displayAttributes: [],
    validationError: null
};

const setCategoryAttributeOption = (state, action) => {
    const { payload } = action;
    const newState = {
        ...state,
        categoryAttributes: arrayUtils.shallowCopyArrayObjects(
            state.categoryAttributes
        )
    };
    const attribute = newState.categoryAttributes.find(
        a => a.id === payload.attributeId
    );
    const options = arrayUtils.shallowCopyArrayObjects(attribute.options);
    if (!attribute.isMultiSelect) {
        options.map(o => (o.isActive = false));
        attribute.numberOfValuesSelected = 0;
    }
    if (payload.optionValue) {
        const option = options.find(o => o.value === payload.optionValue);
        option.isActive = payload.activate;
        if (payload.activate) {
            attribute.numberOfValuesSelected++;
        } else {
            attribute.numberOfValuesSelected--;
        }
    }
    attribute.options = options;
    return newState;
};

const updateCategoryAttributesOptionsStatuses = state => {
    const newState = {
        ...state,
        categoryAttributes: arrayUtils.shallowCopyArrayObjects(
            state.categoryAttributes
        )
    };
    const draftTermAttributes =
        newState.draftAttributes.termAttributeValues || [];
    const findCategoryAttribute = attributeId =>
        newState.categoryAttributes.find(a => a.id === attributeId);
    draftTermAttributes.forEach(draftTermAttribute => {
        const categoryAttribute = findCategoryAttribute(draftTermAttribute.id);
        if (!categoryAttribute) return;
        categoryAttribute.options.forEach(
            option =>
                (option.isActive = draftTermAttribute.values.includes(
                    option.value
                ))
        );
        categoryAttribute.numberOfValuesSelected =
            draftTermAttribute.values.length;
    });
    return newState;
};

const findTitleForAttributeId = (categoryAttributes, attributeId) => {
    const categoryAttribute = categoryAttributes.find(
        a => a.id === attributeId
    );
    return categoryAttribute ? categoryAttribute.title : null;
};

const createDisplayAttributes = (categoryAttributes, draftAttributes) => {
    const result = [];
    if (!draftAttributes.termAttributeValues) return result;
    draftAttributes.termAttributeValues.forEach(tav => {
        const title = findTitleForAttributeId(categoryAttributes, tav.id);
        const value = tav.values.join(', ');
        if (!title || !value) return;
        result.push({
            title,
            value
        });
    });
    return result;
};

const setDraftAttributes = (state, action) => {
    const newState = {
        ...state,
        draftAttributes: {
            ...action.payload
        }
    };
    updateDisplayAttributes(newState);
    return newState;
};

const updateDisplayAttributes = newState => {
    newState.displayAttributes = createDisplayAttributes(
        newState.categoryAttributes,
        newState.draftAttributes
    );
    return newState;
};

const setCategoryAttributes = (state, action) => {
    const newState = {
        ...state,
        categoryAttributes: arrayUtils.shallowCopyArrayObjects(action.payload)
    };
    updateDisplayAttributes(newState);
    return newState;
};

const resetAttributes = () => {
    return { ...initialState };
};

const validate = newState => {
    const attributesWithoutValue = [];
    newState.categoryAttributes.forEach(attribute => {
        if (attribute.minNumberOfValues === 0) {
            return;
        }
        if (attribute.options.length === 0) {
            // There were no options to choose from.
            // May not happen when backend implementation is done,
            // we should not get an empty list of options.
            return;
        }
        const values = attribute.options.reduce((acc, option) => {
            if (option.isActive) {
                acc.push(option.value);
            }
            return acc;
        }, []);
        if (values.length === 0) {
            attributesWithoutValue.push(attribute.title);
        }
    });

    if (attributesWithoutValue.length > 1) {
        var lastTitle = attributesWithoutValue.pop();
        newState.validationError = `Ange ${attributesWithoutValue.join(
            ', '
        )} och ${lastTitle}.`;
    } else if (attributesWithoutValue.length > 0) {
        newState.validationError = `Ange ${attributesWithoutValue.pop()}.`;
    } else {
        newState.validationError = null;
    }

    return newState;
};

const reducers = {
    RESET_ATTRIBUTES: resetAttributes,
    SET_CATEGORY_ATTRIBUTES: setCategoryAttributes,
    SET_DRAFT_ATTRIBUTES: setDraftAttributes,
    SET_CATEGORY_ATTRIBUTE_OPTION: setCategoryAttributeOption,
    UPDATE_CATEGORY_ATTRIBUTES_OPTIONS_STATUSES: updateCategoryAttributesOptionsStatuses
};

export default (state, action) => {
    if (!config.isSyiAttributesEnabled) {
        return initialState;
    }
    state = state || initialState;
    const reducer = reducers[action.type];
    if (reducer) {
        return validate(reducer(state, action));
    }
    return state;
};
